import React from 'react'
import { SvgIconProps } from '../Icon.types'

export const FooterYouTube: React.FC<SvgIconProps> = ({
  width = 28,
  height = 29,
  fill = 'currentColor',
  title = '',
  className,
  ...props
}) => (
  <svg
    viewBox='0 0 28 29'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className={className}
    aria-hidden={!title}
    focusable='false'
    width={width}
    height={height}
    {...props}
  >
    <path
      d='M12.0312 11.3154L17.1456 14.2686L12.0312 17.2217V11.3154Z'
      fill={fill}
    />
    <path
      d='M0 0.25V28.25H28V0.25H0ZM23.4325 19.0067C23.2061 19.8544 22.5389 20.5216 21.6923 20.748C20.1567 21.1592 14 21.1592 14 21.1592C14 21.1592 7.84328 21.1592 6.30766 20.748C5.46109 20.5216 4.79391 19.8544 4.5675 19.0067C4.15625 17.4722 4.15625 14.2686 4.15625 14.2686C4.15625 14.2686 4.15625 11.065 4.5675 9.52938C4.6798 9.11235 4.89964 8.73213 5.20502 8.42674C5.51041 8.12136 5.89063 7.90152 6.30766 7.78922C7.84328 7.37797 14 7.37797 14 7.37797C14 7.37797 20.1567 7.37797 21.6923 7.78922C22.1094 7.90152 22.4896 8.12136 22.795 8.42674C23.1004 8.73213 23.3202 9.11235 23.4325 9.52938C23.8438 11.065 23.8438 14.2686 23.8438 14.2686C23.8438 14.2686 23.8438 17.4722 23.4325 19.0067Z'
      fill={fill}
    />
  </svg>
)

export default FooterYouTube
